// Import lib
import { preloadImage } from '../libs/preloadImage';

export async function preloadImages(imageList = []) {
    // If the table is empty or invalid
    if (!imageList || !Array.isArray(imageList) || !imageList.length > 0) {
        console.warn(
            `Error while preloading images\nError message: image table empty of ivalid`,
        );
        return;
    }

    // Get image preload promise list
    const promises = imageList.map((image) =>
        preloadImage(image.url).catch((err) => {
            console.warn(
                `Error while preloading image with id: ${image.id}\nError message: ${err.message}`,
            );
        }),
    );

    // Wait for all the promise to be done
    await Promise.all(promises);
}
